import { useI18n } from "../i18n";

export function WikiCard({ wiki }) {
  const { tr } = useI18n();
  if (!wiki?.extract) return null;
  return (
    <div data-testid="wiki-card" className="border border-[#E2E8F0] rounded-3xl p-5 bg-white">
      <span className="font-bold text-sm text-[#334155]">📖 {tr("From Wikipedia")}</span>
      <p className="text-sm text-[#334155] leading-relaxed mt-2">{wiki.extract}</p>
      <a href={wiki.url} target="_blank" rel="noreferrer" data-testid="wiki-card-link"
        className="inline-block mt-2 text-sm font-extrabold text-[#2563EB] hover:underline">
        {tr("Read the full article on Wikipedia")} →
      </a>
    </div>
  );
}

export function MediaCards({ media, name }) {
  const { tr } = useI18n();
  if (!media) return null;
  return (
    <>
      {media.emblem?.url && (
        <div data-testid="emblem-card" className="border border-[#BFD4F2] rounded-3xl p-5 bg-white text-center">
          <span className="font-bold text-sm text-[#1D4ED8] block text-left">🏳️ {tr(media.emblem.label?.startsWith("Flag") ? "Flag" : "Emblem")} — {name}</span>
          <img src={media.emblem.url} alt={media.emblem.label || `Emblem of ${name}`} loading="lazy"
            className="max-h-32 mx-auto mt-3 rounded border border-[#EEF3FA]" />
          <p className="text-[0.58rem] text-[#94A3B8] mt-2">{media.emblem.credit}</p>
        </div>
      )}
      {media.map?.url && (
        <div data-testid="map-card" className="border border-[#BFD4F2] rounded-3xl p-5 bg-[#F6FAFF]">
          <span className="font-bold text-sm text-[#1D4ED8]">🗺️ {tr("Map of")} {name}</span>
          <img src={media.map.url} alt={`Locator map of ${name}`} loading="lazy"
            className="w-full max-h-52 object-contain mt-3 rounded" />
          <p className="text-[0.58rem] text-[#94A3B8] mt-2">{media.map.credit}</p>
        </div>
      )}
    </>
  );
}
